import { ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { CommonService } from '../common-service';
import { MessageService } from 'primeng/api';
import { MarkdownService } from '../markdown-service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { catchError, take, timeout } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Clipboard } from '@angular/cdk/clipboard';
import { ActivatedRoute, Router } from '@angular/router';
import { SanitizationService } from '../sanitization.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-get-answer',
  templateUrl: './get-answer.component.html',
  styleUrls: ['./get-answer.component.scss']
})
export class GetAnswerComponent implements OnInit {
  searchcollection: any = ''
  availableCollections: any
  selectedCollection: any
  timer = false
  searchcontainer: any = true
  suggestions: any
  errorMessage = false
  answersArray: any = []
  firstInitial: any
  username: any
  eventSource: EventSource | undefined;
  @ViewChild('scrollMe') myScrollContainer!: ElementRef;
  streamedData: string[] = [];
  displayedData: any = '';
  token:any
  question:any = '';
  showtextbox = false
  loader: boolean=true;
  saved_answers: any;
  rows: number = 10;
  totalrecords = 0
  first: number = 0;
  pagenumber: number = 1;
  showHistory: boolean=true
  translatedAnswer: any;
  language: any='';
  questionId: any;
  showhnonenglishTab: boolean=false;
  cannedId!: any;
  cannedanswer: boolean=false;
  isCopied: { [key: number]: boolean } = {};
  isBotMenu: boolean=false;
  botMenu: any[] = [];
  selectedBotMenuTitle: { [key: number]: string } = {};
  selectedSearchOption: any= "All";
  showChunkModal = false
  selectedChunks: any[] = [];
  chunkListenerAttached = false;
  highlightedChunkId: string | null = null;
  private shouldScrollToHighlighted = false;
  sanitizedQuestion!: SafeHtml;
  sanitizedAnswer!: SafeHtml;
  constructor(private api: CommonService, private messageService: MessageService, private http: HttpClient,
    private markdownService: MarkdownService, private sanitizer: DomSanitizer,private sanitizeService:SanitizationService,
    private elementRef: ElementRef, private renderer: Renderer2,private route: Router,
    private clipboard: Clipboard,private router: ActivatedRoute,
    private readonly changeDetectorRef: ChangeDetectorRef,) {
    this.username = localStorage.getItem("username")
    this.firstInitial = this.username.charAt(0).toUpperCase();
    this.token = localStorage.getItem('token')
  }

  ngOnInit(): void {
    this.api.getMethod('get-collections/v2').subscribe((data: any) => {
      this.availableCollections = data
      this.selectedCollection = localStorage.getItem('selectedCollection') ? localStorage.getItem('selectedCollection') : data[0].collectionName;
      setTimeout(() => {
        this.savedAnswerBasedCollection()
      }, 1000)
      if (this.selectedCollection) {
        this.getPinnedQuestions()
      }
    })
    this.router.params.subscribe(params => {
      this.searchcollection = params['question'];
    })
    this.attachChunkClickListeners();
    
  }


  getPinnedQuestions() {
    let payload = {
      "collection_name": this.selectedCollection,
      "page": 1,
      "limit": 4
    }
    this.api.postMethod('get-collection-pinned-answers', payload).subscribe({
      next: (data) => {
        if (data.collection_name.length > 0) {
          this.suggestions = data.collection_name
        }
        else {
          this.suggestions = []
        }
      },
      error: (error) => {
      }
    })
  }

  changeCollection(e: any) {
    this.selectedCollection = e.value
    localStorage.setItem('selectedCollection',this.selectedCollection)
    this.searchcontainer = true
    this.answersArray = [];
    this.loader=true
    this.getPinnedQuestions()
    this.savedAnswerBasedCollection()
  }

  selectedpinitem(data: any) {
    this.searchcollection = data
    this.searchcontainer = false
    this.detectlanguage()  
  }

  scrollToBottom(): void {
    try {
      const el = this.myScrollContainer.nativeElement as HTMLElement;
      el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
      this.changeDetectorRef.markForCheck();
    } catch (err) {}
  }
  
  handleBotMenuSelection(payload: string, id: any) {
    if (id !== undefined) {
      this.selectedBotMenuTitle[id] = payload;
    }
    this.searchcollection = payload;
    this.onEnterSearchText();
  }

  onEnterSearchText() {
    if (/^\s*[\n\r]*$/.test(this.searchcollection) || this.showtextbox==true) {
      return; 
  }else{
    this.scrollToBottom()
    this.showChunkModal = false
    const textarea = document.getElementById('chatgpt') as HTMLTextAreaElement;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = '1.5rem'; 
    }
    this.searchcontainer = false
    this.showtextbox = true
    this.errorMessage = false
    this.question = this.searchcollection;
    this.searchcollection = '';
    this.timer = true;
    if (this.question === undefined || this.question === '' || this.question.length < 2) {
      return;
    }
    let url = `${environment.mainApi}search-ques-ans-in-bot?collection=`+this.selectedCollection+`&stream=false&question=`+this.question+`&translate=true&translate_model=1&token=`+this.token
    console.log('Connecting to:', url);

      this.http.get(url).subscribe({
        next: (response: any) => {
          console.log('API response:', response);
          this.timer = false;
      let apiResponse = response
      let parsedAnswer;
      let isBotMenu = false;
      let botMenu: any[] = [];
      try {
        parsedAnswer = JSON.parse(response.answer);
        if (Array.isArray(parsedAnswer) && parsedAnswer[0]?.buttons) {
          isBotMenu = true;
          botMenu = parsedAnswer;
          this.displayedData = parsedAnswer[0].text;
        } else {
          this.displayedData = response.answer;
        }
      } catch {
        this.displayedData = response.answer;
      }
      const answerId = Date.now().toString(); 
      const answerObject = {
        question: this.question,
        answer: this.displayedData,
        showTranslated: false,
        cannedanswer: this.cannedanswer,
        questionId: this.questionId,
        language: this.language,
        isBotMenu: isBotMenu,
        botMenu: botMenu,
        confidence:response.confidence,
        answered_by:response.answered_by,
        chunksWithDocuments:apiResponse?.chunksWithDocuments|| [],
        answerId: answerId
      };

          this.answersArray = [...this.answersArray, { ...answerObject }];
          answerObject.question = '';
          answerObject.answer = '';
          this.resetCurrentQn();
          this.answersArray.forEach((data: any) => (this.isCopied[data.questionId] = false));
          console.log('this.answersArray', this.answersArray);
          this.changeDetectorRef.detectChanges();
          this.showtextbox = false;
          this.changeDetectorRef.detectChanges();
          setTimeout(()=>{this.selectedBotMenuTitle={}},5000)
          this.scrollToBottom()
        },
        error: (error: any) => {
          console.error('Error:', error);
          this.timer = false;
          this.errorMessage = true;
        }
      });
  }}


attachChunkClickListeners(): void {
  if (this.chunkListenerAttached) return;
  this.chunkListenerAttached = true;

  const container = this.elementRef.nativeElement as HTMLElement;

  this.renderer.listen(container, 'click', (event: Event) => {
    const clicked = event.target as HTMLElement;
    
    const chunkSpan = clicked.closest('span[chunk_id]') as HTMLElement | null;
    if (!chunkSpan) return;

    const chunkId = chunkSpan.getAttribute('chunk_id');
    
    const answerBlock = chunkSpan.closest('.chunk-most-parent') as HTMLElement | null;
    if (!answerBlock) {
      console.warn('No .chunk-most-parent found for clicked chunk.');
      return;
    }

    const answerTypeAttr = answerBlock.getAttribute('data-answer-type');
    const questionIndex:any = answerBlock.getAttribute('data-question-index');
    
    const answerTypeDataset = (answerBlock.dataset && answerBlock.dataset['answerType']) || undefined;

    const answerType = answerTypeAttr ?? answerTypeDataset;
    if (!answerType) return;

    const parentAnswer = (answerType === 'saved-answers') ? this.saved_answers.slice(0,5).reverse() : this.answersArray;
    if (!parentAnswer) {
      console.warn('No parentAnswer found on component for:', answerType);
      return;
    }

    let questionObj = parentAnswer.find((item:any, index:any) => {
      return parseInt(index) === parseInt(questionIndex);
    });
    this.selectedChunks = questionObj.chunksWithDocuments || [];
    this.highlightedChunkId = chunkId ? (Number(chunkId)).toString() : null;

    if (!this.showChunkModal) {
      this.openSidePanel();
    }

    // flag so ngAfterViewChecked knows to scroll
    this.shouldScrollToHighlighted = true;
  });
}

ngAfterViewChecked() {
  if (this.shouldScrollToHighlighted && this.showChunkModal) {
    this.shouldScrollToHighlighted = false;

    setTimeout(() => {
      const highlightedCard = this.elementRef.nativeElement
        .querySelector('.chunk-mini-card.highlighted') as HTMLElement | null;
      if (highlightedCard) {
        highlightedCard.scrollIntoView({ behavior: 'smooth'});
      }
    },500);
  }
}

 


openSidePanel(): void {
  console.log("function sidepanel");
  this.showChunkModal = true;
}

navigateToDoc(chunk:any){
  const dataToPass = { documentId: chunk.document_id, collectionId: chunk.collection_id };
  this.api.setData(dataToPass);
  this.route.navigate(['collection', chunk.collection_name, 'document', chunk.document_id],
    { state: { highlight: chunk.chunk_text } }
  );
}

  copyChunkExcerpt(text: string): void {
    this.clipboard.copy(text);
    this.changeDetectorRef.detectChanges();
  }

  copyQuestionandAns(text: string): void {
    this.clipboard.copy(text);
    this.changeDetectorRef.detectChanges();
  }
  
  ngOnDestroy(){
    this.eventSource?.close()
  }
 detectlanguage(){
  let payload={
    "text": this.searchcollection
  }
  this.api.postMethod('language/detect',payload).subscribe({
    next:(res)=>{
      this.language=res.data.language;
      this.onEnterSearchText()
      },
      error:(error) => {
        console.error('API Error:', error);
        this.messageService.add({ severity: 'error', detail: error.error.detail});
      }
  })
 }
 translateAnswer(questionId:any){
  let payload={
    "question_id": questionId,
    "targetLanguage": this.language
}
  this.api.postMethod('api/translate-answer',payload).subscribe({
    next:(res)=>{
      this.translatedAnswer=res.data.translatedAnswer
      this.answersArray = this.answersArray.map((answer:any) => {
        if (answer.questionId === questionId) {
          return { ...answer, translatedAnswer: this.translatedAnswer };
        }
        return answer;
      });
      this.resetCurrentQn();
      this.changeDetectorRef.detectChanges();
    },
      error:(error) => {
        console.error('API Error:', error);
        this.messageService.add({ severity: 'error', detail: error.error.detail});
      }
  })
 }
resetCurrentQn(){
  this.question = '';
  this.displayedData = '';
  this.questionId = '',
  this.cannedanswer = false; 
}
  sanitizeMessage(message: string): SafeHtml {
    return this.sanitizeService.sanitizeMessage(message);
   }
  copyToClipboard(text: string,id:number): void {
    this.clipboard.copy(text);
    this.isCopied[id] = true;
    this.changeDetectorRef.detectChanges();
    setTimeout(() => {
      this.isCopied[id] = false;
      this.changeDetectorRef.detectChanges();
    }, 5000);
  }
  autoExpand(event: Event): void {
    const target = event.target as HTMLTextAreaElement;
    if (target) {
      target.style.height = 'auto';
      target.style.height = target.scrollHeight + 'px';
    }
  }
  
  onPageChange(event:any) {
    this.loader=true
    this.first = event.first;
    this.pagenumber = event.page+1;
    this.savedAnswerBasedCollection()
  }

  savedAnswerBasedCollection(){
    this.saved_answers = ''
    let payload =
      {            
        "collection": this.selectedCollection,
        "page": 1,
        "limit": 10,
        "Filter": this.selectedSearchOption 
    }
    this.api.postMethod('get-question-history?page='+this.pagenumber+'&collection='+this.selectedCollection,payload).subscribe({
      next:(data:any)=>{
        this.loader = false
        this.saved_answers = (data?.[this.username]?.[this.selectedCollection] || []).map((item: any) => {
          let isBotMenu = false;
          let botMenu: any[] = [];

          try {
            const parsed = JSON.parse(item.answer);
            if (Array.isArray(parsed) && parsed[0]?.buttons) {
              isBotMenu = true;
              botMenu = parsed;
              item.answer = parsed[0].text;
            }
          } catch (e) {
            // Not JSON - leave answer as is
          }

          
          // ✅ Precompute sanitized versions here
          const sanitizedQuestion = this.sanitizeService.sanitizeMessage(
            item.question,
          );

          const sanitizedAnswer = this.sanitizeService.sanitizeMessage(
            item.answer,
          );

          return {
            ...item,
            isBotMenu,
            botMenu,
            sanitizedQuestion,  // ✅ add sanitized versions
            sanitizedAnswer
          };
        });
        this.totalrecords = data?.total_count
        setTimeout(() => {
          this.scrollToBottom();
        }, 500);
      },
      error:(error:any)=>{
      }
   })
  }
  toggleHistory(){
    this.showHistory=!this.showHistory
  }
 
} 
